import BusEvent from "common/services/BusEvent"
import { db } from "../../common/config/Firebase"
import addTaskToInvoiceDetail from "./detail/addTaskToInvoiceDetail"
import { calculateTotalInvoice } from "./detail/calculateInvoicesInfo"
import findInvoiceDetailByIdUseCase from "./detail/findInvoiceDetailByIdUseCase"
import { NO_CREATION } from "./config"

const invoicesCollection = db.collection('invoices')
const invoicesCreationCollection = db.collection('invoicesCreation')

const updateInvoiceUseCase = async (invoice, oldInvoice, modifiedPayed) => {
    if (invoice.newTask) {
        await addTaskToInvoiceDetail(invoice, invoice.ivaPercent, invoice.taskReference)
        invoice.newTask = false
    } else {
        const data = await findInvoiceDetailByIdUseCase(invoice.id)
        const { base, total } = calculateTotalInvoice(data.data, invoice.ivaPercent)
        invoice.basePrice = base
        invoice.totalPrice = total
    }

    const { invoiceDate } = invoice
    if (invoiceDate && typeof invoiceDate.getMonth === 'function') {
        invoice.invoiceDate = invoiceDate.getTime()
    }

    if (modifiedPayed) {
        invoice.payedDate = invoice.payed ? new Date().getTime() : ""
    }

    if (invoice.typeCreation != oldInvoice.typeCreation) {
        if (!invoice.autogenerated) {
            invoice.isPrincipal = true
            invoice.datePrincipal = new Date().getTime()
        }

        if (invoice.typeCreation === NO_CREATION) {
            invoice.isPrincipal = false
            invoice.datePrincipal = ""
            await invoicesCreationCollection.doc(invoice.id).delete()
        } else {
            await invoicesCreationCollection.doc(invoice.id).set({
                typeCreation: invoice.typeCreation,
                invoiceId: invoice.id,
                initialDate: new Date(),
                lastDate: new Date()
            })

            invoice.invoicePrincipalId = invoice.id
        }
    }

    BusEvent.publish(BusEvent.UPDATE_INVOICE, { invoice, oldInvoice })

    return invoicesCollection.doc(invoice.id).set(invoice)
}

export default updateInvoiceUseCase